<template>
  <span>
    <div
      class="machine-item"
      :key="`result-${resultIndex}`"
      v-for="(result, resultIndex) in calculateResults()"
    >
      <MachineItemsImageWrapper
        :resultIndex="resultIndex"
        :randomPercentNumber="randomPercentNumber[resultIndex][resultIndex]"
        :result="result"
      />
      <div class="machine-information-wrapper">
        <MachineItemsInformationsContent
          :financeTypeLength="financeTypeLength"
          :financeType="financeType"
          :result="result"
          :ab_test="ab_test"
          :hidePrices="hidePrices"
        />
        <button @click="openForm(result, pageTypeGTM)">
          Kostenloses Angebot einholen
        </button>
      </div>
    </div>
  </span>
</template>

<script>
import { filterMachines } from './../modules/filter'
import { randomPercentNumberByIndex } from './../modules/functions'

import MachineItemsImageWrapper from './MachineItemsImageWrapper'
import MachineItemsInformationsContent from './MachineItemsInformationsContent'

export default {
  components: {
    MachineItemsImageWrapper,
    MachineItemsInformationsContent
  },
  props: {
    pageTypeGTM: {
      type: String,
      default: '',
      validator: function(value) {
        return ['resultPage', 'interimResult'].includes(value)
      }
    },
    surveyData: {
      type: Object,
      default: () => {}
    },
    machineList: {
      type: Array,
      default: () => []
    },
    financeTypeLength: {
      type: Number,
      default: 0
    },
    financeType: {
      type: [String, Array]
    },
    ab_test: {
      type: Boolean
    },
    hidePrices: {
      type: Boolean
    }
    
  },
  data() {
    return {
      randomPercentNumber: [
        { 0: randomPercentNumberByIndex(0) },
        { 1: randomPercentNumberByIndex(1) },
        { 2: randomPercentNumberByIndex(2) }
      ]
    }
  },
  methods: {
    calculateResults() {
      let currentMachineList = this.machineList
      let current = filterMachines(this.surveyData, currentMachineList)
      let fullList = []
      current.sort((a, b) => a.priorisierung - b.priorisierung)

      current.slice(0, 3).forEach(function(machine) {
        fullList.push(machine)
        if (machine['related-next-machine-by-kauri-option']) {
          currentMachineList.filter(x => {
            if (x['kauri-option'].match(machine['related-next-machine-by-kauri-option'])) {
              return fullList.push(x)
            }
          });
        }
      })
      return fullList.slice(0, 3)
    },
    openForm(result, pageTypeGTM) {
      this.$emit(
        'openForm',
        result,
        pageTypeGTM,
        this.randomPercentNumber[0][0]
      )
    }
  }
}
</script>
